// extracted by mini-css-extract-plugin
module.exports = {"register":"page-register_register__1ouua","text":"page-register_text__3URkb","text2":"page-register_text2__1oa2J"};